import React, { useRef, useState } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormInputText from "src/components/Forms/FormInputText";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import { downloadFile } from "src/global/FileDownloader";
import moment from "moment";
import * as data from "yup";

const PMSDayExportDialog = ({ handleSubmit, handleClose }) => {
  const { t } = useTranslation();

  function pmsDayExport(values, helpers) {
    helpers.setSubmitting(true);

    downloadFile(
      `/api/v1/accounting/invoices/pms_day_export.xlsx?from=${moment(
        values.from
      ).startOf("month")}&to=${moment(values.to).endOf("month")}`,
      `PMS Tages Export ${moment(values.from).format("YYYY-MM-dd")} - ${moment(
        values.to
      ).format("YYYY-MM-dd")}.xlsx`
    )
      .then(() => handleSubmit())
      .catch((err) => {
        console.log(err);
        helpers.setSubmitting(false);
      });
  }

  return (
    <Modal show={true} onHide={handleClose} size="lg">
      <Formik
        initialValues={{
          from: moment().startOf("month").format(moment.HTML5_FMT.DATE),
          to: moment().endOf("month").format(moment.HTML5_FMT.DATE),
        }}
        enableReinitialize={true}
        onSubmit={pmsDayExport}
      >
        {({ isSubmitting, handleSubmit }) => (
          <>
            <Modal.Header>
              <Modal.Title>
                {t("accounting.pms_day_export_dialog.title")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <FormInputText label="Von" name="from" type={"date"} required />
                <FormInputText label="Bis" name="to" type={"date"} required />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                {t("accounting.invoice_details_dialog.close")}
              </Button>
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <Spinner size={"sm"} className={"mr-2"} animation="border" />
                )}
                {t("accounting.pms_day_export_dialog.download")}
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default PMSDayExportDialog;
